function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import PictureComponent from "/components/core/picture/picture-component";
import ParagraphComponent from "/components/core/paragraph/paragraph-component";
import { StyledImageGalleryComponent } from "./image-gallery-component.scss";
class ImageGalleryComponent extends PureComponent {
    moveToPage() {
        const { href } = this.props;
        window.location.href = href;
    }
    getSpecificImageStyle() {
        const { grayscale } = this.props;
        let style = grayscale == "true" ? {
            filter: "grayscale(100%)"
        } : {};
        return style;
    }
    render() {
        const { url, alt, paragraph, shadow, href, screenRatios, shouldTrackMouseEvents } = this.props;
        const specifyStyle = this.getSpecificImageStyle();
        return /*#__PURE__*/ _jsxs(StyledImageGalleryComponent, {
            className: classnames("image-gallery", {
                shadow,
                clickable: href
            }),
            onClick: href ? this.moveToPage : undefined,
            children: [
                /*#__PURE__*/ _jsx(PictureComponent, {
                    specificImageStyle: specifyStyle,
                    src: url,
                    alt: alt,
                    pictureClass: "social-proof-gallery-picture",
                    screenRatios: screenRatios,
                    shouldTrackMouseEvents: shouldTrackMouseEvents
                }),
                paragraph && /*#__PURE__*/ _jsx(ParagraphComponent, _object_spread({}, paragraph))
            ]
        });
    }
    constructor(props){
        super(props);
        this.moveToPage = this.moveToPage.bind(this);
    }
}
export { ImageGalleryComponent as default };
ImageGalleryComponent.defaultProps = {
    url: "",
    alt: "",
    grayscale: false
};
